const state = () => ({
  firebaseAuthUser: null,
  firestoreUser: null,
  googleProfile: null,
  person: null,
  self: null,
  user: null,

  reports: null,

  isAutoAuthing: true,
  isAuthCheckRequested: false,

  isSigningIn: false,
  isSigningOut: false,

  didSignInFail: false,

  isShowingHelp: false,

  aliasOptions: [],

  demoMode: null,
  didDemoModeFail: false,
  isLoadingDemoMode: false,

  didDevModeFail: false,
  isLoadingDevMode: false,

  confirmDemoModeChange: false,
  errorDemoModeChange: false,
  inputDemoMode: null,
  inputDemoModeChange: null,

  fnUnwatchReport: {},
  fnUnwatchUser: null,
})

export default state
